import { jsx as _jsx } from "react/jsx-runtime";
import { Notice } from '@tencent/cms-design-component';
import React, { useEffect, useState } from 'react';
import ls from '../OldRender/utils/localStorage';
var NoticeComponent = function(param) {
    var noticeDesc = param.noticeDesc, noticeType = param.noticeType, longTimeMode = param.longTimeMode, _noFix = param.noFix, noFix = _noFix === void 0 ? false : _noFix;
    var LS_NOTICE_KEY = 'INTL_NOTICE_TIP';
    var LS_NOTICE_SWITCH_KEY = 'INTL_NOTICE_SWITCH';
    var CONST_ONE = 1;
    var CONST_TWO = 2;
    // const { properties } = JSON.parse(componentObject); // 获取cms的具体配置信息
    var ref = useState(-1), noticeVisible = ref[0], setNoticeVisible = ref[1]; // 公告展示逻辑，默认没取到ls里面值时为-1，展示为1，点击关闭后设为2
    var ref1 = useState(null), noticeSwitch = ref1[0], setNoticeSwitch = ref1[1]; // 公告模式切换
    useEffect(function() {
        var noticeVal = ls.get(LS_NOTICE_KEY);
        var noticeSwitchVal = ls.get(LS_NOTICE_SWITCH_KEY);
        if (!noticeVal) {
            setNoticeVisible(1);
        } else {
            setNoticeVisible(noticeVal);
        }
        setNoticeSwitch(noticeSwitchVal);
    }, []);
    // 返回的配置数据必须是对象，才会进行后续操作
    // ls异步没取到值时通知不显示
    if (noticeVisible < 0) {
        return null;
    }
    // const { txt, type, longTimeMode } = dataFormat.formatNotice(properties);
    // 模式切换时，重置保存的值，让通知显示出来
    if (longTimeMode === noticeSwitch) {
        if (!longTimeMode && noticeVisible === CONST_TWO) {
            //  一次性模式+ls为2时不展示Notice
            return null;
        }
    } else {
        ls.set(LS_NOTICE_KEY, CONST_ONE);
    }
    ls.set(LS_NOTICE_SWITCH_KEY, longTimeMode);
    return(/*#__PURE__*/ _jsx("div", {
        id: "langnotice",
        children: /*#__PURE__*/ _jsx(Notice, {
            noFix: noFix,
            txt: noticeDesc,
            type: noticeType,
            onNoticeClick: function() {
                if (!longTimeMode) {
                // 一次性模式下点击关闭设置ls
                // ls.set(LS_NOTICE_KEY, CONST_TWO);
                }
            }
        })
    }));
};
export default NoticeComponent;
